import { SpacingTokensTable } from '@af/design-system-docs-ui';
import similarityDo from "../../../../src/pages/foundations/spacing/_assets/similarity-do.png";
import similarityDont from "../../../../src/pages/foundations/spacing/_assets/similarity-dont.png";
import proximityDo from "../../../../src/pages/foundations/spacing/_assets/proximity-do.png";
import proximityDont from "../../../../src/pages/foundations/spacing/_assets/proximity-dont.png";
import hierarchyDo from "../../../../src/pages/foundations/spacing/_assets/hierarchy-do.png";
import hierarchyDont from "../../../../src/pages/foundations/spacing/_assets/hierarchy-dont.png";
import opticalAdjustmentDo from "../../../../src/pages/foundations/spacing/_assets/optical-adjustment-do.png";
import opticalAdjustmentDont from "../../../../src/pages/foundations/spacing/_assets/optical-adjustment-dont.png";
import * as React from 'react';
export default {
  SpacingTokensTable,
  similarityDo,
  similarityDont,
  proximityDo,
  proximityDont,
  hierarchyDo,
  hierarchyDont,
  opticalAdjustmentDo,
  opticalAdjustmentDont,
  React
};